import { render, staticRenderFns } from "./SportsGameResult.vue?vue&type=template&id=3e262f14&"
import script from "./SportsGameResult.vue?vue&type=script&lang=js&"
export * from "./SportsGameResult.vue?vue&type=script&lang=js&"
import style0 from "./SportsGameResult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports